import { Spinner } from "react-bootstrap";

// The loader the app already uses everywhere: the grey wash and centred spinner
// that CustomTable lays over a table while it fetches. It lived inline in
// CustomTable, so screens that are not tables — the attendance grid, the modals
// hanging off it — had nothing to reuse and grew their own little spinners.
// Pulling it out keeps one loader across the app.
//
// The overlay is absolutely positioned, so whatever wraps it must be positioned
// too (`position: relative`), otherwise it covers the nearest positioned
// ancestor instead of the block it belongs to.
const OverlayLoader = ({ text, zIndex = 9, rounded = false }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      background: "#d0d0d09c",
      position: "absolute",
      inset: 0,
      zIndex,
      borderRadius: rounded ? 6 : undefined,
    }}
  >
    <Spinner animation="border" variant="secondary" />
    {text && <span className="fw-bold text-secondary">{text}</span>}
  </div>
);

export default OverlayLoader;
